import { api, ApiResponse } from './api';

export interface CommentUser {
  id: string;
  name: string;
  email: string;
  avatar?: string;
}

export interface CommentReaction {
  emoji: string;
  count: number;
  user_ids: string[];
}

export interface CommentAttachment {
  id: string;
  filename: string;
  original_name: string;
  mime_type: string;
  size: number;
  url: string;
  path: string;
  is_image: boolean;
  created_at: string;
}

export interface Comment {
  id: string;
  item_id: string;
  user_id: string;
  parent_id?: string;
  content: string;
  content_html?: string;
  mentions?: string[];
  is_edited: boolean;
  edited_at?: string;
  created_at: string;
  updated_at: string;
  user?: CommentUser;
  replies?: Comment[];
  reactions?: CommentReaction[];
  attachments?: CommentAttachment[];
  is_deleted?: boolean;
}

export interface CreateCommentData {
  content: string;
  content_html?: string;
  parent_id?: string;
  mention_user_ids?: string[];
  attachment_ids?: string[];
}

export interface UpdateCommentData {
  content: string;
  content_html?: string;
}

export const commentApi = {
  getAll: async (workspaceId: string, itemId: string): Promise<Comment[]> => {
    const response = await api.get<ApiResponse<Comment[]>>(
      `/api/v1/workspaces/${workspaceId}/items/${itemId}/comments`
    );
    return response.data.data || [];
  },

  create: async (workspaceId: string, itemId: string, data: CreateCommentData): Promise<Comment> => {
    const response = await api.post<ApiResponse<Comment>>(
      `/api/v1/workspaces/${workspaceId}/items/${itemId}/comments`,
      data
    );
    return response.data.data!;
  },

  update: async (workspaceId: string, itemId: string, id: string, data: UpdateCommentData): Promise<Comment> => {
    const response = await api.patch<ApiResponse<Comment>>(
      `/api/v1/workspaces/${workspaceId}/items/${itemId}/comments/${id}`,
      data
    );
    return response.data.data!;
  },

  delete: async (workspaceId: string, itemId: string, id: string): Promise<void> => {
    await api.delete(`/api/v1/workspaces/${workspaceId}/items/${itemId}/comments/${id}`);
  },

  addReaction: async (workspaceId: string, itemId: string, commentId: string, emoji: string): Promise<void> => {
    await api.post(`/api/v1/workspaces/${workspaceId}/items/${itemId}/comments/${commentId}/react`, { emoji });
  },
};
